import { render, staticRenderFns } from "./appstore-copyright.vue?vue&type=template&id=3f1b103c&scoped=true"
import script from "./appstore-copyright.vue?vue&type=script&lang=js"
export * from "./appstore-copyright.vue?vue&type=script&lang=js"
import style0 from "./appstore-copyright.vue?vue&type=style&index=0&id=3f1b103c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b103c",
  null
  
)

export default component.exports